import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsG2aComponent } from './simple-icons-g2a.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsG2aComponent ],
    exports:      [ SimpleIconsG2aComponent ],
    bootstrap:    []
})
export class SimpleIconsG2aModule {}
